import { createContext } from 'react';

import { FeatureFlags } from './FeatureFlags.types';

const FeatureFlagsContext = createContext<Partial<FeatureFlags>>({});

export { FeatureFlagsContext };
export default FeatureFlagsContext;
